import { USER_ROLE } from './common';

export const PATH = {
  AUTH: {
    SIGNIN: '/auth/signin',
    RESET_PASSWORD: '/auth/reset-password',
    RESET_PASSWORD_CONFIRM: '/auth/reset-password/confirm',
  },

  ADMIN: {
    INDEX: '/admin',
    HOME: '/admin/lesson',

    STUDENT: {
      INDEX: '/admin/student',
      ADD: '/admin/student/add',
      SETTING: '/admin/student/setting',
      DETAIL: {
        INDEX: '/admin/student/detail/',
      },
    },

    INSTRUCTOR: {
      INDEX: '/admin/instructor',
      ADD: '/admin/instructor/add',
      DETAIL: {
        INDEX: '/admin/instructor/detail/',
      },
    },

    STAFF: {
      INDEX: '/admin/staff',
      ADD: '/admin/staff/add',
      SETTING: '/admin/staff/setting',
      DETAIL: {
        INDEX: '/admin/staff/detail/',
      },
    },

    LESSON: {
      INDEX: '/admin/lesson',
      ADD: '/admin/lesson/add',
      SETTING: '/admin/lesson/setting',

      BOARD: {
        INDEX: '/admin/lesson/board',
        CLASS_NOTICE: '/admin/lesson/board/:lessonId/class-notice',
        PROGRESS_VOD: '/admin/lesson/board/:lessonId/progress-vod',
        QUIZ_ASSIGNMENT: '/admin/lesson/board/:lessonId/quiz-assignment',
      },
    },

    ATTENDANCE: {
      INDEX: '/admin/attendance',
      ZOOM_ACCOUNT: '/admin/attendance/zoom-account',
    },

    NOTICE: {
      INDEX: '/admin/notice',

      ADD: '/admin/notice/add',
      EDIT: '/admin/notice/edit/',
      DETAIL: '/admin/notice/detail/',
    },

    PAYMENT: {
      INDEX: '/admin/payment',
    },

    NOTIFICATION: {
      AUTOMATION: '/admin/notification/automation',
      TEMPLATES: '/admin/notification/templates',
    },

    COUNSELING: {
      INDEX: '/admin/counseling',
      ADD: '/admin/counseling/add',
      DETAIL: {
        INDEX: '/admin/counseling/detail/',
      },
    },

    KAKAO_TALK: {
      INDEX: '/admin/kakao-talk',
    },

    ENROLLMENT: {
      INDEX: '/admin/enrollment',
    },
  },

  INSTRUCTOR: {
    INDEX: '/instructor',
    HOME: '/instructor/home',

    ATTENDANCE: {
      INDEX: '/instructor/attendance',
    },

    LESSON: {
      INDEX: '/instructor/lesson',

      DETAIL: {
        INDEX: '/instructor/lesson/detail/',
      },

      BOARD: {
        INDEX: '/instructor/lesson/board',

        CLASS_NOTICE: '/instructor/lesson/board/:lessonId/class-notice',
        PROGRESS_VOD: '/instructor/lesson/board/:lessonId/progress-vod',
        QUIZ_ASSIGNMENT: '/instructor/lesson/board/:lessonId/quiz-assignment',
      },
    },

    STUDENT: {
      INDEX: '/instructor/student',
    },

    COUNSELING: {
      INDEX: '/instructor/counseling',
      ADD: '/instructor/counseling/add',
      DETAIL: {
        INDEX: '/instructor/counseling/detail/',
      },
    },

    NOTICE: {
      INDEX: '/instructor/notice',
      DETAIL: '/instructor/notice/detail/',
    },
  },

  STUDENT: {
    INDEX: '/student',
    HOME: '/student/home',
    MY_CLASS: '/student/my-class',

    ATTENDANCE: {
      INDEX: '/student/attendance',
    },

    ASSIGNMENT: {
      INDEX: '/student/assignment',
      LOG: '/student/assignment/log',
      SETUP: '/student/assignment/setup',
    },

    CLASSROOM: {
      INDEX: '/student/classroom',
      DETAIL: '/student/classroom/:lessonId',
    },

    SETTINGS: {
      ACCOUNT: '/student/settings/account',
      ACCOUNT_STUDENT_INFO_EDIT: '/student/settings/account/edit',
      NOTIFICATIONS: '/student/settings/notifications',
    },

    LESSON: {
      INDEX: '/student/lesson',

      DETAIL: {
        INDEX: '/student/lesson/detail/',
      },

      BOARD: {
        INDEX: '/student/lesson/board',

        CLASS_NOTICE: '/student/lesson/board/:lessonId/class-notice',
        PROGRESS_VOD: '/student/lesson/board/:lessonId/progress-vod',
        QUIZ_ASSIGNMENT: '/student/lesson/board/:lessonId/quiz-assignment',
      },

      LESSON_NOTICE: {
        INDEX: '/student/lesson/notice',
      },
    },

    ACTIVITIES: {
      INDEX: '/student/lesson/activities',
    },

    REPORT_CARD: {
      INDEX: '/student/report-card',
    },

    NOTICE: {
      INDEX: '/student/notice',
      DETAIL: '/student/notice/detail/',
    },
  },

  STAFF_SHARED: {
    INDEX: '/staff',
    QR: '/staff/qr',
    QR_DETAIL: '/staff/qr/:lessonSessionId',
  },

  /** 로그인 없이 접근하는 공개 페이지 */
  PUBLIC: {
    LESSON_QR_ATTENDANCE: '/public/lesson-attendance/qr/:lessonSessionId',
    TERMS: '/public/terms',
    PRIVACY: '/public/privacy',
    SUPPORT: '/public/support',
    ZOOM: '/public/zoom',
    /** 출결 태블릿(웹 전용 라우트) — 로그인 만료와 무관하게 스캔이 계속돼야 해서 인증 가드 밖에 둔다 */
    ATTENDANCE_TABLET: '/public/attendance-tablet',
  },

  PARENT: {
    INDEX: '/parent',
    HOME: '/parent/home',
    SELECT_STUDENT: '/parent/select-student',
    MY_CLASS: '/parent/my-class',

    CHILD_LESSON: {
      INDEX: '/parent/lesson',

      DETAIL: {
        INDEX: '/parent/lesson/detail/',
      },

      LESSON_NOTICE: {
        INDEX: '/parent/lesson/notice',
      },
    },

    ATTENDANCE: {
      INDEX: '/parent/attendance',
    },

    ACTIVITIES: {
      INDEX: '/parent/activities',
    },

    FEEDBACK: {
      INDEX: '/parent/feedback',
    },

    REPORT_CARD: {
      INDEX: '/parent/report-card',
    },

    NOTICE: {
      INDEX: '/parent/notice',
      DETAIL: '/parent/notice/detail/',
    },
  },
};

export const HOME_PATH_BY_ROLE: Record<string, string> = {
  [USER_ROLE.ADMIN]: PATH.ADMIN.HOME,
  [USER_ROLE.STAFF]: PATH.ADMIN.HOME,
  [USER_ROLE.INSTRUCTOR]: PATH.INSTRUCTOR.HOME,
  [USER_ROLE.STUDENT]: PATH.STUDENT.HOME,
  [USER_ROLE.PARENT]: PATH.PARENT.HOME,
};
